import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetRealMoneyBalancePlayerListRequest } from
  '@/api/mga-real-money-balance/get-mga-real-money-balance-player-list.request';
import { GetRealMoneyBalancePlayerListCsvRequest } from
  '@/api/mga-real-money-balance/get-mga-real-money-balance-player-list-csv.request';

export class MgaRealMoneyBalanceApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly apiUrl: Ref<string>,
  ) { }

  public get getRealMoneyBalancePlayerList(): GetRealMoneyBalancePlayerListRequest {
    return new GetRealMoneyBalancePlayerListRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/report/mga/player`,
      HttpMethods.GET,
    );
  }

  public get getRealMoneyBalancePlayerListCsv(): GetRealMoneyBalancePlayerListCsvRequest {
    return new GetRealMoneyBalancePlayerListCsvRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/report/mga/player/csv`,
      HttpMethods.GET,
    );
  }
}
